import React from 'react';
import ProgressBar from 'progressbar.js';
import { parse } from 'twemoji-parser';
import emojiRegex from 'twemoji-parser/dist/lib/regex'
import { enlabelEndpoint } from '../util/endpoints';

export default class CustomizeMessage extends React.Component {
  state = {
    saved: false
  }
  constructor(props) {
    super(props);
    // this.debouncedHandleChange = ((fn, delay) => {
    //   let timeout;

    //   return function () {
    //     const context = this,
    //       args = arguments;

    //     clearTimeout(timeout);
    //     timeout = setTimeout(function () {
    //       fn.apply(context, args);
    //     }, delay || 500);
    //   };
    // })(this.handleChange)

    const throttle = (func, limit) => {
      let inThrottle
      return function () {
        const args = arguments
        const context = this
        if (!inThrottle) {
          func.apply(context, args)
          inThrottle = true
          setTimeout(() => inThrottle = false, limit)
        }
      }
    }
    this.throttledHandleChange = throttle(this.handleChange, 700)
  }

  componentDidMount() {
    this.radial = new ProgressBar.Circle(this.refs.widthRadial, {
      strokeWidth: 16,
      easing: 'easeInOut',
      duration: 300,
      color: '#f07597',
      trailColor: '#e3e3e3',
      trailWidth: 16,
      svgStyle: null
    });
  }

  _ensureLength = async (text, strippedText, emojiEntities) => {
     return $.ajax({
      type: "POST",
      url: enlabelEndpoint + "/text_width",
      data: { 
        text: text,
        emoji_entities_string: JSON.stringify(emojiEntities || []),
        stripped_text: strippedText
      }
    })
  }

  handleCustomText = (e) => {
    this.handleChange((customText, strippedText, emojiEntities) => {
      this.props.updateText(
        customText, 
        strippedText,
        emojiEntities,
        () => {this.setState({ saved: true })}
      )
    })
  }

  handleChange = async (cb) => {
    const res = await this._ensureLength(
      this.refs.customMessage.value,
      this.refs.customMessage.value.replace(emojiRegex, ''),
      parse(this.refs.customMessage.value, { assetType: "png" })
    )
  
    if (res.extra_char_count == 0) {
      this.radial.animate(res.fitted_text_image_width / res.label_width);
    } else {
      this.radial.animate(1.0)
    }

    // clear any emojis
    // this.refs.customMessage.value = this.refs.customMessage.value.replace(/([\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2694-\u2697]|\uD83E[\uDD10-\uDD5D])/g, '')

    if (res.extra_char_count > 0) {
      this.refs.customMessage.value = this.refs.customMessage.value.slice(0, -res.extra_char_count)
    }

    if (cb) {
      cb(
        this.refs.customMessage.value, 
        this.refs.customMessage.value.replace(emojiRegex, ''),
        parse(this.refs.customMessage.value, { assetType: "png" })
      )
    } else {
      setTimeout(() => { this.handleChange(() => {}) }, 600)
    }
  }

  render() {

    return (
      <React.Fragment>

        <input
          ref="customMessage"
          className="field"
          type="text"
          onBlur={this.handleCustomText}
          onChange={ () => {
            this.setState({ saved: false })
            this.throttledHandleChange()
            if (this.props.customText !== this.refs.customMessage.value) {
              this.props.disableAddToCart(true)
            }
          } }
          placeholder="Your custom message"
          id="custom-text"
          name="properties[custom_text]"
          style={{ paddingRight:"35px", width: "100%", fontSize: "16px", left: 0 }} />
        
        <div ref="widthRadial" style={{ width: '27px', height: '20px', lineHeight: 0, position: 'relative', top: '-33px', right: '5px', float: 'right'}}>
        </div>

        <input
          type="button"
          disabled={this.props.loadingPreview || this.state.saved}
          href="javascript:void(0);"
          style={{ width: "100%", textAlign: "center", display: "block", marginTop: "10px", clear: "both" }}
          defaultValue={this.props.loadingPreview ? "Saving..." : this.state.saved ? "Saved!" : "Save"}
          className="action-button submit" />
        
      </React.Fragment>
    )
  }
}